import { ExpandMore } from '@mui/icons-material';
import { Collapse, LinearProgress, Stack, Typography } from '@mui/material';
import IconTransition from 'components/shared/IconTransition';
import React, { ReactNode } from 'react';
import { TComponentChild, TOnClick } from 'types/props';
import SidebarMenuItem from './SidebarMenuItem';

interface ISidebarMenuSectionProps {
	title: ReactNode;
	children: ReactNode;
	open?: boolean;
	onTitleItemClick?: TOnClick;
	progress?: number | null;
	progressTotal?: number | null;
	startIcon?: TComponentChild | null;
	testIdTopic?: 'sso' | 'scim' | 'jit' | 'xaa' | 'audit';
}

const SidebarMenuSection: React.FC<ISidebarMenuSectionProps> = ({
	title,
	children,
	open = false,
	onTitleItemClick = undefined,
	startIcon = null,
	progress = null,
	progressTotal = null,
	testIdTopic = undefined
}) => (
	<Stack
		data-testid="sidebar-menu-section"
		data-section-topic={testIdTopic}
		overflow="hidden"
		flexShrink={0}
	>
		<SidebarMenuItem
			data-testid="sidebar-menu-section-title-item"
			disableHover
			buttonBaseProps={{ disableRipple: true, onClick: onTitleItemClick }}
			startIcon={startIcon}
			endIcon={
				<Stack direction="row" alignItems="center" gap={1}>
					{progress !== null && progressTotal !== null && (
						<>
							<Typography variant="body2">
								{progress}/{progressTotal}
							</Typography>
							<LinearProgress
								data-testid="menu-section-progress"
								variant="determinate"
								value={(progress * 100) / progressTotal}
								sx={{ width: 50, borderRadius: 4 }}
							/>
						</>
					)}
					<IconTransition
						transitionProperty="transform"
						apply={open}
						to="rotateX(180deg)"
					>
						<ExpandMore color="action" />
					</IconTransition>
				</Stack>
			}
		>
			<Typography variant="body1" fontWeight={700}>
				{title}
			</Typography>
		</SidebarMenuItem>
		<Collapse in={open} unmountOnExit>
			<Stack mt={2} gap={1} data-testid="sidebar-menu-section-content">
				{children}
			</Stack>
		</Collapse>
	</Stack>
);

export default SidebarMenuSection;
